export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name='${name}']`)

  if (element) {
    return element.getAttribute('content')
  }
}

export function findElement(root, selector) {
  if (typeof root == 'string') {
    selector = root
    root = document
  }

  return root.querySelector(selector)
}

export function removeElement(element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element)
  }
}

export function insertAfter(element, referenceNode) {
  return referenceNode.parentNode.insertBefore(element, referenceNode.nextSibling)
}
